import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqbaggv8wd: FaireProductEntity = {
  token: "p_fqbaggv8wd",
  type: "product",
  name: "Sakura Japanese Washi Stickers JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/3ebf490783f97073e5146a518ab38175bb479273abbaa38b65b5e266710585c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f670083207aed701c31359858c29c5cf73cf9cc1ca5bd494ed431accb6d13e78.jpeg",
    "https://cdn.faire.com/fastly/413f1898798f185e23c80231ee3029af3c0457a7fcf0107170fd0fa4ad082939.jpeg"
  ],
  priceDollars: 2,
  description: "Add a touch of Japan to cards, gift wrap and journals with these Sakura washi stickers. Made in Japan, they make an easy add-on for gift shops and checkout counters, and a fun souvenir for fans of Japanese design.\n\nFeatures\n\n * Japanese washi stickers: a classic Japanese craft item for scrapbooks, planners, letters and gift wrap \n * Collect the series: also available in Warlord, Origami, O-Gi Fan, Maneki Neko, Japanese Foods, Origami Cranes, Ukiyo Mt. Fuji \nSpecifications\n\n * Type: Washi stickers \n * Design: Sakura \n * Inner pack: 1 \n * Case pack: 100 \n * Origin: Japan ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:05.345Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
